var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_c('b-button',{attrs:{"size":"is-small","native-type":"submit","type":"is-primary","outlined":"","loading":_vm.saving,"disabled":_vm.saving}},[_vm._v(_vm._s(_vm.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }